module.exports = new __parcel__URL__("clipboard-darkmode.ede97435.svg").toString();